"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Courses = void 0;
exports.getEnrolled = getEnrolled;
exports.getPublished = getPublished;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("./utils");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

function apiFetch(_x) {
  return _apiFetch.apply(this, arguments);
}
/**
 * Fetch all publicly available courses for the domain
 * @returns Promise resolving to an array of published courses
 * @example
 * const courses = await ChWebSdk.Courses.getPublished()
 */


function _apiFetch() {
  _apiFetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if ((0, _utils.isBrowser)()) {
              _context.next = 2;
              break;
            }

            throw new Error('Courses SDK methods can only be called in a browser environment');

          case 2:
            _context.next = 4;
            return fetch((0, _absoluteUrlRuntime.resolveUrl)(path));

          case 4:
            response = _context.sent;

            if (!(response.status === 401)) {
              _context.next = 7;
              break;
            }

            throw new Error('Authentication required');

          case 7:
            if (!(response.status === 404)) {
              _context.next = 9;
              break;
            }

            throw new Error('No Skilljar account found for the current user');

          case 9:
            if (response.ok) {
              _context.next = 11;
              break;
            }

            throw new Error("Courses API request failed: ".concat(response.statusText));

          case 11:
            return _context.abrupt("return", response.json());

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _apiFetch.apply(this, arguments);
}

function getPublished() {
  return _getPublished.apply(this, arguments);
}
/**
 * Fetch courses the currently logged-in user is enrolled in.
 * Requires the user to be authenticated and have a linked Skilljar account.
 * @returns Promise resolving to an array of enrolled courses
 * @example
 * const courses = await ChWebSdk.Courses.getEnrolled()
 */


function _getPublished() {
  _getPublished = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var _data$results;

    var data;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return apiFetch('/customerEducation/publishedCourses');

          case 2:
            data = _context2.sent;
            return _context2.abrupt("return", (_data$results = data.results) !== null && _data$results !== void 0 ? _data$results : []);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getPublished.apply(this, arguments);
}

function getEnrolled() {
  return _getEnrolled.apply(this, arguments);
}
/**
 * Courses bounded context
 */


function _getEnrolled() {
  _getEnrolled = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var _data$results2;

    var data;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return apiFetch('/customerEducation/myRecentCourses');

          case 2:
            data = _context3.sent;
            return _context3.abrupt("return", (_data$results2 = data.results) !== null && _data$results2 !== void 0 ? _data$results2 : []);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getEnrolled.apply(this, arguments);
}

var Courses = {
  getPublished: getPublished,
  getEnrolled: getEnrolled
};
exports.Courses = Courses;